import api from 'config/api.config';
import { toast } from 'react-toastify';

export const getAccountsByUserId = async () => {
  try {
    const response: any = await api.get('/api/accounts/my-accounts');
    return response;
  } catch (error: any) {
    const message = error.response?.data?.message || 'Failed to fetch accounts';
    toast.error(message);
    if (error.response) {
      return error.response;
    }
    throw new Error(message);
  }
};

export const getActiveAccountsByUserId = async () => {
  try {
    const response: any = await api.get('/api/accounts/my-active-accounts');
    return response;
  } catch (error: any) {
    const message = error.response?.data?.message || 'Failed to fetch active accounts';
    toast.error(message);
    if (error.response) {
      return error.response;
    }
    throw new Error(message);
  }
};

export const addOrModifyRule = async (social_media_account_id: any, rule_name: string, rule: any) => {
  try {
    const response: any = await api.post('/api/accounts/manage-rule', {
      social_media_account_id,
      rule_name,
      rule,
    });
    return response.data;
  } catch (error: any) {
    const message = error.response?.data?.message || 'Failed to manage rule';
    toast.error(message);
    return error.response ? error.response.data : error;
  }
};

export const fetchRules = async (social_media_account_id: any) => {
  try {
    const response: any = await api.get(`/api/accounts/rules?social_media_account_id=${social_media_account_id}`);
    return response.data;
  } catch (error: any) {
    const message = error.response?.data?.message || 'Failed to fetch rules';
    toast.error(message);
    return error.response ? error.response.data : error;
  }
};

export const performRuleAction = async (social_media_account_id: any, rule_name: string, status: any, is_active: boolean) => {
  try {
    const response: any = await api.post('/api/accounts/rule-action', {
      social_media_account_id,
      rule_name,
      status,
      is_active,
    });
    return response.data;
  } catch (error: any) {
    const message = error.response?.data?.message || 'Failed to perform rule action';
    toast.error(message);
    return error.response ? error.response.data : error;
  }
};

export const fetchAccountSettings = async (account_id: any) => {
  try {
    const response: any = await api.post('/api/accounts/social-account-global-settings', { account_id });
    return response.data;
  } catch (error: any) {
    const message = error.response?.data?.message || 'Failed to fetch account settings';
    toast.error(message);
    return error.response ? error.response.data : error;
  }
};

export const toggleAccountDeletedStatus = async (account_id: any, is_deleted: boolean) => {
  try {
    const response: any = await api.post('/api/accounts/delete-account', { account_id, is_deleted });
    return response.data;
  } catch (error: any) {
    const message = error.response?.data?.message || 'Failed to toggle account deleted status';
    toast.error(message);
    throw error.response ? error.response.data : error;
  }
};

export const toggleCategoryActiveStatus = async (account_id: any, category: string, is_active: boolean) => {
  try {
    const response: any = await api.post('/api/accounts/manage-category', { account_id, category, is_active });
    return response.data;
  } catch (error: any) {
    const message = error.response?.data?.message || 'Failed to toggle category active status';
    toast.error(message);
    throw error.response ? error.response.data : error;
  }
};

export const toggleAccountActiveStatus = async (account_id: any, is_active: boolean) => {
  try {
    const response: any = await api.post('/api/accounts/manage-account', { account_id, is_active });
    return response.data;
  } catch (error: any) {
    const message = error.response?.data?.message || 'Failed to toggle account active status';
    toast.error(message);
    throw error.response ? error.response.data : error;
  }
};

export const deleteRule = async (ruleId: string) => {
  try {
    const response: any = await api.delete(`/api/accounts/rule/${ruleId}`);
    return response.data;
  } catch (error: any) {
    const message = error.response?.data?.message || 'Failed to delete rule';
    toast.error(message);
    throw error;
  }
};

export const renameRule = async (ruleId: string, ruleName: string) => {
  try {
    const response: any = await api.put(`/api/accounts/rule/${ruleId}`, { rule_name: ruleName });
    return response.data;
  } catch (error: any) {
    const message = error.response?.data?.message || 'Failed to rename rule';
    toast.error(message);
    throw error;
  }
};

export const updateTimezone = async (accountId: string, timezoneOffset: number) => {
  try {
    const response: any = await api.post('/api/accounts/update-timezone', {
      account_id: accountId,
      timezone_offset: timezoneOffset,
    });
    return response.data;
  } catch (error: any) {
    const message = error.response?.data?.message || 'Failed to update timezone';
    toast.error(message);
    throw error;
  }
};

export const getAccountsWithRules = async () => {
  try {
    const response: any = await api.get('/api/accounts/accounts-with-rules');
    return response;
  } catch (error: any) {
    const message = error.response?.data?.message || 'Failed to fetch accounts with rules';
    toast.error(message);
    if (error.response) {
      return error.response;
    }
    throw new Error(message);
  }
};